import React, {useEffect, useState} from 'react'
import {SettingPageTitle} from '../components/header/SettingPageTitle'
import {collection, doc, onSnapshot} from 'firebase/firestore'
import db from '../../../../services/firebase'
import {useAuth} from '../../../modules/auth'
import useCrispChat from 'app/Hooks/useCrispChat'
import {KTCard} from '_metronic/helpers'
import {ListLoading} from 'app/components/ListLoading'
import Button from 'app/components/Button'

const SettingFramework = () => {
  const [activeFrameworks, setActiveFrameworks] = useState<string[]>([])
  const {currentUser} = useAuth()
  const {toggleCrispChat} = useCrispChat()
  const [isDataFetching, setIsDataFetching] = useState(true)

  useEffect(() => {
    getActiveFrameworks()
  }, [])

  const getActiveFrameworks = () => {
    try {
      setIsDataFetching(true)
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const testsCollectionRef = collection(tenantRef, 'active_frameworks')

      const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
        const frameworksData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          frameworks: doc.data().frameworks,
        }))
        const frameworks = frameworksData[0]?.frameworks || []
        setActiveFrameworks(frameworks)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting frameworks:', error)
    } finally {
      setTimeout(() => setIsDataFetching(false), 500)
    }
  }

  return (
    <>
      <SettingPageTitle icon='Settings.svg' title='Settings' desc='Manage your settings'>
        Personnel Management
      </SettingPageTitle>
      {isDataFetching ? (
        <KTCard>
          <div className='position-relative' style={{height: '500px'}}>
            <ListLoading />
          </div>
        </KTCard>
      ) : (
        <div className='card px-2'>
          <div className='card-body'>
            {activeFrameworks.length > 0 ? (
              <div className='table-responsive' style={{maxHeight: '500px', overflowY: 'auto'}}>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold fs-7' style={{color: '#5A5A5A'}}>
                      <th className='min-w-200px '>FRAMEWORK</th>
                      <th className='min-w-100px'>STATUS</th>
                      <th className='min-w-50px'></th>
                    </tr>
                  </thead>
                  <tbody>
                    {activeFrameworks.map((framework) => (
                      <tr key={framework}>
                        <td>
                          <div className='d-flex align-items-center fs-6'>{framework}</div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center'>
                            <span
                              className='badge fs-7'
                              style={{
                                color: '#0E9F6E',
                                background: '#E8F8F4',
                              }}
                            >
                              Active
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div
                className='d-flex flex-column align-items-center justify-content-center'
                style={{height: '200px'}}
              >
                <div className='text-center'>
                  <p className='fs-4 fw-bold text-gray-900 mb-2'>No Active Frameworks Found</p>
                  <p className='text-gray-500 mb-3'>
                    It seems you haven't set up any frameworks yet.
                  </p>
                </div>
                <Button
                  btnType='primary'
                  onClick={(e) => toggleCrispChat()}
                >
                  Set Up Framework
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default SettingFramework
